export default Object.freeze({
  TEXT_INPUT: 'text input',
  DATE_INPUT: 'date input',
  EVENT_DATE_INPUT: 'event date input',
  DROPDOWN_INPUT: 'dropdown input',
});
